import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
export function ErrorAlert() {
    const errorMessage = t({
        message: 'Something went wrong, please reload the page and try again',
        comment: 'team profile: failed to load data to display -add team members- dropdown',
    });
    return <Alert message={errorMessage} appearance="danger"/>;
}
